/** THIS CONTAINS ALL WORDS THAT ARE CONSIDERED STATICALLY PRESENT IN THE APP, DYNAMICALLY ADDED CONTENTS WILL NOT BE HANDLED **/
export default {
  'app.loading': 'Finitura di alcuni processi...',
  'app.logout': 'Disconnessione...',
  'auth.unauthorized':
    'La tua sessione è scaduta. Accedi nuovamente per completare questo processo.',
  'auth.unauthorized-special-feature':
    'Devi accedere per continuare a utilizzare questa funzione.',

  //NavBar
  'nav.profile': 'Profilo',
  'nav.edit-profile': 'Modifica Profilo',
  'nav.my-classrooms': 'Le Mie Aule',
  'nav.settings': 'Impostazioni',
  'nav.logout': 'Esci',
  'nav.home': 'CASA',
  'nav.classrooms': 'AULE',
  'nav.educators': 'EDUCATORI',
  'nav.about': 'DETTAGLI',
  'nav.sign-in': 'ACCEDI',
  'nav.sign-up': 'REGISTRATI',
  'nav.apply': 'APPLICARE COME EDUCATORE',
  'nav.site-language': 'Lingua del sito',

  //Home
  'home.hero-typo-1': 'Introduzione',
  'home.hero-typo-2': 'Un nuovo livello di esperienza',
  'home.hero-typo-3': "Nell'apprendimento e nell'insegnamento delle lingue",
  'home.hero-typo-4': 'Attraverso le classi online',
  'home.hero-option-1': '1. Impara lingue diverse.',
  'home.hero-option-2': '2. Comunica con persone diverse.',
  'home.hero-option-3': '3. Insegna la lingua che ami.',
  'home.hero-cta': 'Le caratteristiche che offriamo',
  'home.features': 'Le Nostre Caratteristiche',
  'home.feature-1': "Portare l'esperienza di classe tradizionale online",
  'home.feature-1-1':
    "Insieme alla proliferazione delle app Web per l'apprendimento delle lingue, arrivano vari studi condotti per valutare la loro efficacia. La maggior parte dei risultati indica spesso la mancanza di supporto comunicativo o motivi che supporta un flusso principale o un'esperienza di classe tradizionale. In InteReact, abbiamo fatto del nostro meglio per emulare l'esperienza della classe fisica.",
  'home.feature-2': 'Gratuito per tutti',
  'home.feature-2-2':
    'InteReact si impegna a rendere la sua piattaforma praticamente accessibile a tutti.\n' +
    'Pertanto, siamo orgogliosi della nostra politica gratuita per tutti che afferma che il pagamento non è richiesto se non concordato da entrambe le parti - studenti ed educatori.\n' +
    'Se desideri saperne di più sulla nostra Politica gratuita per tutti, inclusi i Termini di servizio per i pagamenti, fai clic',
  'home.feature-2-link': 'qui.',
  'home.feature-3': 'Strettamente monitorato',
  'home.feature-3-3':
    "Per garantire la sicurezza digitale e la privacy dei nostri utenti, monitoriamo attentamente le attività e affrontiamo immediatamente i violatori dei nostri termini e politiche. Condanniamo fermamente i comportamenti che promuovono la nudità, la violenza e il discorso dell'odio.",
  'home.feature-4': 'Impara al tuo ritmo',
  'home.feature-4-4':
    "Portare l'esperienza in classe online comporta ancora il vantaggio di apprendere le lezioni secondo il proprio ritmo e tempo.",

  //NOT FOUND
  'notfound.desc':
    "Looks like the page you are looking at is missing. Don't worry though, our explorer is on the case.",
  'notfound.redirectmsg': "For the meantime, why don't you head back home?",
  'notfound.btntext': 'Back Home',

  //Error Messages
  'login.user-banned':
    "L'utente associato a questo account è stato bannato dalle nostre autorità di regolamentazione.",
  'login.user-banned-contact-support':
    "Se ritieni che l'azione sia stata fatta per errore e desideri revocare il divieto, fai una chiacchierata con noi.",
  'login.user-banned-link': 'Contatta il supporto ora',
  'login.credentials-unmatched':
    "L'email e la password che hai inserito non corrispondono ai nostri dati.",
  'login.invalid-password-length': 'La password deve contenere 6 o più caratteri.',
  'signup.invalid-password-length': 'La password deve contenere 6 o più caratteri.',
  'login.email-invalid': "L'email non è valida.",
  'signup.email-invalid': "L'email non è valida.",
  'signup.passwords-unmatched': 'Le password non corrispondono.',
  'signup.email-exists':
    "L'email che hai inserito non corrispondono ai nostri dati. Inserisce una diversa, per favore.",
  'server.unexpected-error': 'Oops! Si è verificato un errore imprevisto.',

  //Footer
  'footer.languages-available': 'Lingue',
  'footer.about-intereact': "Cos'è InteReact",
  'footer.legal-terms': 'Note legali',
  'footer.survey': 'Fai il sondaggio',
  'footer.contact': 'Hai una domanda?',
  'footer.about-content':
    "InteReact è un servizio di apprendimento delle lingue gratuito che si rivolge a tutti i tipi di studenti. Questa applicazione mira a fungere da portale esclusivo per l'apprendimento delle lingue e l'insegnamento attraverso l'uso di aule digitali. Il progetto è stato creato in adempimento dei requisiti per il Laurea in Scienze Informatiche.",
  'footer.about-read': 'Leggi di più',
  'footer.terms': 'Termini di Servizio',
  'footer.privacy': 'Informativa sulla Privacy',
  'footer.cookies': 'Le Politiche di Gratuito per Tutte',
  'footer.survey-explanation':
    "Questo sondaggio copre aree come il livello di convenienza, il tasso di soddisfazione e la variazione rispetto ad altre app per l'apprendimento delle lingue. Tuttavia, l'efficienza di questa impostazione di apprendimento linguistico in termini di quante conoscenze uno studente impara in un certo tempo non sarà coperta.",
  'footer.answer-survey': 'Rispondi sondaggio',

  //How To Apply
  'how-to-become-educator': 'Come posso diventare un educatore su InteReact?',
  'how-to-professional': 'Profilo Didattico Professionale',
  'how-to-native': 'Madrelingua A Cui Piace Insegnare',
  'how-to-bitriprof': 'Competenza Bilingue o Multilingue',
  'how-to-user-type': 'Registrati Come Educatore',
  'how-to-user-type-desc':
    'La registrazione come educatore è necessaria per gli amministratori per verificare con successo il tuo account come consentito per insegnare.',
  'how-to-professional-desc':
    'Il modo più veloce per essere accettato come educatore e iniziare a creare la tua prima classe è quello di fornire un documento scritto che mostri la tua formazione ed esperienza come educatore. ' +
    'Una persona che è certificata per insegnare o che sta già insegnando una lingua professionale può qualificarsi per un profilo di insegnamento professionale su InteReact.',
  'how-to-native-desc':
    'I madrelingua che desiderano insegnare la propria lingua possono anche richiedere la verifica. Puoi inviare un video che mostra almeno che sei abbastanza bravo con la tua seconda lingua.' +
    ' È anche possibile inviare una e-mail personale che indichi il tuo scopo di aderire. In IntereAct, siamo aperti a quegli amanti delle lingue che vogliono condividere le loro competenze linguistiche a tutti gratuitamente.',
  'how-to-bitriprof-desc':
    "Dimostrare che si può parlare almeno 2 lingue è l'ideale per avere la vostra applicazione verificata.",
  'how-to-send-email': "Invia un'email ad InteReact",
  'how-to-send-email-desc': "Invia un'email ad InteReact",

  //HomeGen
  'homegen.headings': "Fluidità Attraverso L'esposizione Linguistica",
  'homegen.main-intro':
    "Il linguaggio porta sempre significato e riferimenti al di là di sé. I significati di una particolare lingua rappresentano la cultura di un particolare gruppo sociale. In InteReact, crediamo che l'apprendimento delle lingue non sia solo quello di imparare e memorizzare complesse regole grammaticali e ortografia di parole dure, ma apre anche la porta alla comprensione del comportamento della società e dei suoi costumi culturali.",
  'homegen.why-learn-a-language':
    "Attraverso l'approccio Communicative Language Teaching implementato dall'uso di aule online, puoi interagire con altri studenti e il tuo educatore mentre impara la lingua. Altri approcci pedagogici all'apprendimento delle lingue possono essere utilizzati anche a seconda dell'educatore, tuttavia, indipendentemente dall'approccio all'insegnamento, studiare una lingua in IntereAct sarebbe divertente a causa del suo ecosistema interattivo. Ogni classe può ospitare solo almeno 50 studenti, limitando così l'ambiente a un piccolo ecosistema.",
  'homegen.headings-button': 'Saperne di più',
  'homegen.middle-block-headings': 'Parla più di una lingua',
  'homegen.middle-block-icon-1': 'Impara una lingua',
  'homegen.middle-block-icon-2': 'Parla coi nostri educatori',
  'homegen.middle-block-icon-3': "Parla nell'aula",
  'homegen.features-text': 'Vantaggi',
  'homegen.features-title-1': 'Tutti Gratis',
  'homegen.features-title-2': 'Aula Dedicata',
  'homegen.features-title-3': 'Prova di Completamento',
  'homegen.features-title-4': 'Lezione dal Vivo',
  'homegen.features-title-5': 'Interattivo',
  'homegen.featues-title-desc-1':
    "Nessun pagamento ostacola il tuo desiderio di imparare una lingua che si tratti di un hobby o di motivi professionali. Gli educatori sono liberi di insegnare ogni volta che vogliono o durante il loro tempo libero. Grazie mille a coloro che avrebbero condiviso alcuni o anche un po' del loro tempo per insegnare una lingua gratuitamente.",
  'homegen.featues-title-desc-2':
    'Ogni classe può ospitare fino a 50 studenti e 1 educatore. Gli educatori possono anche iniziare la classe anche con soli 5 studenti iscritti, quindi, un piccolo ecosistema interattivo per tutti.',
  'homegen.featues-title-desc-3':
    "Un certificato digitale di completamento sarà rilasciato anche dopo che l'educatore contrassegna la classe come finita. Sarà dato un link che sarà possibile condividere a tutti!",
  'homegen.featues-title-desc-4':
    'Gli educatori possono tenere una lezione dal vivo gratuitamente, ma potrebbe essere limitata a causa del problema delle risorse. Indipendentemente da ciò, imparare sarebbe molto più divertente in tempo reale!',
  'homegen.featues-title-desc-5':
    'Le aule hanno una Conferenza, Assegnazione, Chat, Stream e Calendario Pagine incorporate per facilitare una comunicazione continua. Chattare sarà ancora possibile anche con le lezioni finite!',

  //ClassroomsGen
  'classroomsgen.headings': 'Aule',
  'classroomsgen.cbox-educ-text': 'Educatore',
  'classroomsgen.cbox-lang-spoken-text': 'Lingue Parlate',
  'classroomsgen.cbox-btn-text': 'Iscriviti Ora',
  'classroomsgen.cbox-helper-icon-msg':
    'Gli educatori non possono iscriversi alle aule e gli studenti possono unirsi a un solo massimo di 1 classe.',
  'classroomsgen.students-enrolled': 'Studenti Iscritti',
  'classroomsgen.students-noenrolled': 'Nessun studente attualmente iscritto',
  'classroomsgen.students-enroll': 'Iscriversi',
  'classroomsgen.joining': 'Iscriversi in aula...',
  'classroom.error-email-unverified':
    "L'indirizzo e-mail che stai utilizzando non è verificato. Si prega di inviare una e-mail di verifica.",
  'classroom.error-full': "L'aula è piena",
  'classroom.error-full-desc': 'Cinquanta studenti sono già iscritti.',
  'classroom.error-active': 'Classe Attiva Rilevata',
  'classroom.error-active-desc':
    "Solo una classe può essere iscritta alla volta. Se è ancora possibile, è comunque possibile annullare l'iscrizione a quella corrente andando alla pagina dell'aula. È possibile registrarsi nuovamente dopo che quella corrente è stata impostata su terminata.",
  'classroom.success-join': 'Aderito con successo',
  'classroom.success-join-desc':
    "Congratulazioni! Ti sei iscritto in classe. Si prega di prendere un momento per aggiornare l'applicazione.",
  'classroom.go-to-classroom-page': 'Vai in Classe',

  //Educators
  'educators.filter-by-nationality': 'Nazionalità',
  'educators.filter-by-language': 'Parla anche',
  'educators.search-by-name': 'Cerca educatori coi loro nomi',
  'educators.apply-filter': 'Applica filtro',
  'educators.educators-found-text': 'educatori trovati',
  'educators.educators-found-text-singular': 'educatore trovato',
  'educators.educators-no-rating': 'Nessuna valutazione',
  'educators.educators-speaks': 'Parla',
  'educators.educators-description': 'Descrizione',
  'educators.educators-gender-empty': 'Nessun genere fornito',
  'educators.educators-description-empty': 'Nessuna descrizione fornita',

  //SignIn
  'signin.welcome-msg': 'Bentornato!',
  'signin.email-field': 'E-mail',
  'signin.password-field': 'Password',
  'signin.remember-field': 'Ricordati di me',
  'signin.forgot-field': 'Password Dimenticata',
  'signin.new-to-field': "Nuovo d'InteReact? Registera un account.",
  'signin.terms-and-privacy': "Condizioni d'uso. Informativa sulla privacy.",
  'signin.button': 'Accedi',
  'signin.modal-signing': 'Accedendo...',
  'signin.error-email-existence': "L'e-mail non è collegata a nessun account.",
  'signin.error-unmatch': 'Password e e-mail non corrispondono.',
  'signin.banned': 'Questo account è bannato.',

  //Sign Up
  'signup.bg-headings-1':
    'Impara e Metti alla Prova Le Tue Abilità Linguistiche Oggi Stesso',
  'signup.bg-headings-2': 'Esposizione Linguistica | Fluidità | Comunicare',
  'signup.form': 'Vieni con noi!',
  'signup.form-student': 'Iscriversi come Studente',
  'signup.form-educator': 'Iscriversi come Educatore',
  'signup.form-complete-msg': 'Completa per creare il Suo account.',
  'signup.form-first-name': 'Nome',
  'signup.form-last-name': 'Cognome',
  'signup.form-username': 'Nome utente',
  'signup.form-gender': 'Genere',
  'signup.form-gender-male': 'Maschio',
  'signup.form-gender-female': 'Femminile',
  'signup.form-email': 'Email',
  'signup.form-password': 'Password',
  'signup.form-confirm': 'Conferma la password',
  'signup.form-languages-spoken': 'Lingue Parlate',
  'signup.form-language-already-chosen': 'Hai già scelto questa lingua.',
  'signup.form-language-not-supported': 'Lingua non supportata',
  'signup.form-nationality': 'Nazionalità',
  'signup.form-agree-terms':
    'Accetto i termini del servizio e della privacy di InteReact.',
  'signup.form-see-terms': 'Termini del servizio',
  'signup.form-see-policy': 'Termini del privacy',
  'signup.form-button': 'Iscriviti',
  'signup.form-ahaa-signin': 'Hai già un account? Accedi.',
  'signup.modal-signing': 'Creazione di un account...',
  'sign-up.confirmation-needed':
    'Iscrivendoti, devi accettare i nostri Termini di servizio e la nostra Informativa sulla privacy.',

  //ForgotPassword
  'forgotpassword.headings': 'Reimpostazione Password',
  'forgotpassword.reenter': "Inserisci Nuovamente L'email",
  'forgotpassword.send': 'Invia un Link',
  'forgotpassword.invalid-email': 'Inserisci un indirizzo email valido',
  'forgotpassword.unmatch': 'Le email non corrispondono.',
  'forgotpassword.match-valid': 'Le e-mail sono valide e corrispondenti.',
  'forgotpassword.unexisting': 'Email non collegata a nessun account.',
  'forgotpassword.sent': 'Email è stata inviata.',
  'forgotpassword.emailheadings': 'Verifica Email',
  'forgotpassword.unverified': 'Email Non Verificata',

  //CopyDialog Component
  'copy-dialog.title': 'Copia URL nella Clipboard',
  'copy-dialog.description':
    "Se la funzione di copia non funziona come previsto, copiare l'URL manualmente.",
  'copy-dialog.copied-text': "L'URL è stato copiato nella clipboard.",
  'copy-dialog.agree': 'Copia',
  'copy-dialog.disagree': 'Annulla',

  //All Classrooms
  'all-classrooms.classroom-name': "Nome dell'aula:",
  'all-classrooms.classroom-description': "Descrizione dell'aula:",
  'all-classrooms.view-classroom': 'Vedi Classroom',
  'all-classrooms.join-classroom': 'Iscriviti a Classroom',
  'all-classrooms.dialog-agree': "D'accordo",
  'all-classrooms.dialog-disagree': 'Disaccordo',
  'all-classrooms.dialog-description':
    "Lascerai la pagina Classrooms e verrai reindirizzato a un'altra pagina.",
  'all-classrooms.dialog-title': 'Visualizza i dettagli completi della classe?',
  'all-classrooms.report-classroom': 'Segnala Classroom',
  'all-classrooms.no-results': 'Non ci sono risultati per i filtri:',
  'all-classrooms.no-results-status': "Stato dell'aula",
  'all-classrooms.no-results-status-available': 'Disponibile',
  'all-classrooms.no-results-status-ongoing': 'Incorso',
  'all-classrooms.no-results-status-completed': 'Completato',
  'all-classrooms.view-more-classrooms': 'Visualizza più classi',
  'all-classrooms.clear-filters': 'Rimuovi filtri',
  'all-classrooms.apply-filter': 'Applica il filtro',
  'all-classrooms.search-placeholder': 'Cerca per nome del classroom',

  //All Educators
  'all-educators.full-name-not': 'Il nome completo non è fornito',
  'all-educators.gender-not': 'Il genere non è fornito',
  'all-educators.description-not': 'La descrizione non è fornita',
  'all-educators.users-who-evaluated': 'utenti hanno valutato questo educatore.',
  'all-educators.report': 'Segnala Educatore',
  'all-classrooms.rated by': 'Valutato da',
  'all-classrooms.users': 'utenti',
  'all-educators.view-more-educators': 'Vedi altri educatori',
  'all-educators.search-placeholder': "Cerca per nome dell'insegnante",
  'all-educators.no-results-search-string': "Nome dell'insegnante",

  //Classroom View
  'classroom.not-exist': "Non c'è niente qui. L'aula potrebbe essere stata eliminata.",
  'classroom.user-is-creator': 'Sei il creatore.',
  'user-id.not-found': 'Questo account potrebbe essere stato eliminato.',
  'classroom.checking-status': 'Verifica dello stato',
  'classroom.joining-success-welcome': 'Benvenuto/a nella tua nuova classe',
  'classroom.share-link-description':
    "L'apprendimento delle lingue è più divertente con molte persone. Anche i tuoi amici possono unirsi e imparare insieme a te!",
  'classroom.joining-challenged': 'Sfida di convalida',
  'classroom-join.credentials-required':
    'Il nome completo, la nazionalità e le lingue parlate sono necessari prima di poter entrare in classe. Assicurarsi di fornire prima tutti i campi.',
  'email.unverified': 'Verifica prima il tuo indirizzo email.',
  'classroom-join.joined-already': 'Ti sei già iscritto a questa classe.',
  'classroom-join.started-already': "L'aula è già iniziata.",
  'classroom-join.ended-already': "L'aula è già stata completata.",
  'classroom-join.classroom-not-exist':
    "L'aula è stata cancellata. Si prega di aggiornare la pagina.",
  'classroom-join.limit-reached':
    "L'aula è già pieno. Solo 50 studenti per classe possono iscriversi.",
  'classroom-status.completed': 'CLASSROOM COMPLETATO!',
  'classroom-status.started': "L'AULA È INIZIATA GIÀ!",
  'classroom-status.full': "L'AULA È PIENA!",
  'classroom-status.open': 'GLI SLOT SONO ANCORA APERTI!',
  'classroom-view.go-to-classroom': 'Vai in classe',
  'classroom-view.sign-in-to-join': 'Accedi per unirti',
  'classroom-view.about-creator-label': 'Informazioni sul Creatore:',
  'classroom-view.powered-by': 'Offerto da',
  'classroom-view.translate-from': 'Traduci il testo da 68 lingue disponibili.',
  'classroom-view.translate-to': 'Traduci in',
  'classroom-view.translation': 'Traduzione',
  'classroom-view.translated-from': 'Tradotto da',
  'classroom-view.creator-info': 'Informazioni sul creatore',

  //Classroom Edit
  'form.edit-classroom': 'Modifica Dettagli della Classe',
  'form.editing-classroom': 'Modifica della Classe',
  'form-editing-classroom-success': 'I dettagli della classe sono stati aggiornati!',
  'classroom-validate.not-exist':
    'La classe non si trova. Potrebbe essere stato cancellato.',
  'classroom-validate.completed-already':
    "Questa azione non è più consentita perché l'aula è già stata completata.",
  'classroom-validate.not-creator':
    'Proibito! Potresti perderti. Per favore, fate un passo indietro.',

  //User Inputs Errors
  'input-errors-required': 'Questa parte è obbligatoria.',
  'input-errors-first-name-errlength': 'Il nome deve contenere tra 2 e 32 caratteri.',
  'input-errors-last-name-errlength': 'Il conome deve contenere tra 2 e 32 caratteri.',
  'input-errors-email-invalid': 'Questa e-mail non è valida.',
  'input-errors-password-errlength': 'La password deve essere di almeno 6 caratteri.',
  'input-error-username-empty': 'Il nome utente non deve essere vuoto.',
  'input-error-username-alphanumeric': 'Il nome utente contiene caratteri non validi.',
  'input-error-username-allnumbers': 'Il nome utente deve contenere anche lettere.',
  'input-error-full-name-empty': 'Il nome completo non deve essere vuoto.',
  'input-error-full-name-errlength':
    'Il nome completo deve essere compreso tra 4 e 64 caratteri.',
  'input-error-description-empty': 'La descrizione non deve essere vuota.',
  'input-error-description-errlength':
    'Descrizione deve definire bene, quindi, crediamo che dovrebbe contenere tra 32 e 1024 caratteri.',
  'input-error-languages-empty': 'Le lingue parlate non devono essere vuote.',
  'input-error-cname-errlength':
    'Il nome della classe deve contenere tra 4 e 64 caratteri.',
  'profile.classroom-created': 'La classe è stata creata!',
  'profile.classroom-failed':
    'È consentita solo una classe attiva per educatore. Se si desidera crearne una nuova, impostare la classe attiva corrente su terminata.',
  'profile.classroom-educator-unverified':
    "La verifica è necessaria per creare un'aula. Consulta le qualifiche su come candidarsi come educatore.",
  'profile.classroom-see-how': 'Scopri come applicare',

  //UserMeEdit
  'user-me-edit.languages-placeholder': 'Inserisci una lingua',
  'user-me-edit.nationality-placeholder': 'Scegli la tua nazionalità',
  'user-me-edit.gender-placeholder': 'Inserisci genere',
  'user-me-edit.edit-btn': 'Modifica i miei dettagli',
  'user-me-edit.editing-btn': 'Aggiornamento dei dettagli ...',
  'user-me-edit.profile-updated': 'Il tuo profilo è stato aggiornato con successo.',
  'user-me-edit.apply-btn': 'Fai domanda come educatore',
  'user-me-edit.delete-tooltip': 'Rimuovi immagine',
  'user-me-edit.upload-btn': 'Carica immagine',
  'user-me-edit.change-btn': 'Cambia immagine',

  //Profile
  'profile.add-classroom': 'Aggiungi Classe',
  'profile.edit-profile': 'Modifica Profilo',
  'profile.join-classroom': 'Unisciti alla Classe',
  'profile.classrooms-list': 'Aule',
  'profile.helper-modal-classrooms-what': 'Che sono queste immagine?',
  'profile.helper-modal-classrooms-done':
    'Questa immagine mostrerà le aule che sono già contrassegnate come terminate.',
  'profile.helper-modal-classrooms-current':
    "Questa immagine mostrerà l'aula attiva corrente.",
  'profile.by-educator': 'di',
  'profile.description': 'DESCRIZIONE',
  'profile.send-message': 'Invia un messaggio',
  'profile.full-name': 'Nome Completo',
  'profile.position': 'Ruolo',
  'profile.occupation': 'Occupazione',
  'profile.birthday': 'Compleanno',
  'profile.gender': 'GENERE',
  'profile.username': 'Nome utente',
  'profile.change-avatar': 'Cambia Avatar',
  'profile.size-limit': 'Fino a 10 MB di limite',
  'profile.upload': 'Caricare',
  'profile.languages-spoken': 'LINGUE PARLATE',
  'profile.nationality': 'NAZIONALITÀ',
  'profile.modal-headings': 'Classe Nuova',
  'profile.modal-cname': 'Nome della Classe',
  'profile.modal-cstarts': 'Inizio delle Lezioni',
  'profile.modal-tlanguage': 'Lingua da Insegnare',
  'profile.modal-days-from-sing': 'giorno da oggi',
  'profile.modal-days-from-plu': 'giorni da oggi',
  'profile.modal-input-placeholder': 'Inserisci qui il nome della classe.',
  'profile.modal-button-cancel': 'Annullare',
  'profile.modal-button-create': 'Creare',
  'profile.edit-add-language': 'Aggiungi una lingua qui.',
  'profile.edit-modal-changes': 'I seguenti campi verranno modificati.',
  'profile.edit-modal-proceed': 'Continua',
  'profile.edit-modal-loader-editing': 'Modificando profilo...',
  'profile.edit-modal-success': 'Il profilo utente è stato modificato correttamente.',
  'profile.edit-modal-failure': 'Modifica del profilo utente non riuscita.',
  'profile.edit-languages-spoken':
    'Ora è il momento di mostrare le tue abilità linguistiche',
  'profile.edit-gender': 'Modifica il sesso',
  'profile.edit-nationality': 'Modifica la nazionalità',
  'profile.edit-fullname': 'Aggiungi il tuo nome completo',
  'profile.edit-description': 'Mostra loro i tuoi pensieri',
  'profile.nav-home': 'Casa',
  'profile.nav-classrooms': 'Le Mie Aule',
  'profile.nav-edit-profile': 'Modifica Il Profilo',
  'profile.nav-create-classroom': 'Crea Classe',
  'profile.edit': 'Modifica',
  'profile.avatar-upload-failed':
    "Errore durante il caricamento dell'immagine del profilo. Riprovare.",
  'profile.avatar-upload-size-exceeded': "L'immagine non può superare i 10 MB.",
  'profile.avatar-upload-success':
    'Avatar è stato aggiornato con successo. Si prega di aggiornare la pagina per vedere le modifiche.',
  'nsfw.violated':
    "L'immagine che hai caricato è rientrata in una delle categorie: Nudità, Offensiva, Alcol, Droga, Armi e Minori.",

  //Other Profile
  'other-profile.name-not-added': 'Questo utente non ha ancora aggiunto un nome.',
  'other-profile.languages-spoken-not-added':
    'Questo utente non ha ancora aggiunto una lingua.',
  'other-profile.nationality-not-added': 'Non ancora aggiunto',
  'other-profile.gender-not-added': 'Non ancora aggiunto',
  'other-profile.description-not-added':
    'Questo utente non ha ancora aggiunto una descrizione.',
  'other-profile.nav-go-to-profile': 'Il Mio Profilo',
  'other-profile.banned-icon-tooltip':
    'Questo utente è attualmente vietato dagli amministratori.',
  'other-profile.verified-icon-tooltip':
    'Il profilo educatore di questo utente è approvato e rivisto manualmente dai nostri regolatori.',
  'other-profile.proof-of-skill-label': 'PROVA DEL LIVELLO DI COMPETENZE',
  'other-profile.educator-ratings': 'VALUTAZIONE DI EDUCATORE',
  'other-profile.user-no-review': "L'utente non ha lasciato una recensione.",
  'other-profile.review-label': 'Recensione',

  //Settings
  'settings.option-1': 'Account Relativo',
  'settings.option-2': 'Notifiche di Posta Elettronica',
  'settings.option-3': 'Privacy',
  'settings.six-digit-placeholder':
    'Inserisci il codice che ti abbiamo inviato tramite la tua nuova email',
  'settings.six-digit-error': 'Immettere solo un codice a 6 cifre.',
  'settings.verify-code': 'Verifica il codice',
  'settings.current-email': 'Email Attuale',
  'settings.current-email-placeholder': 'Inserisci il tuo indirizzo email attuale',
  'settings.new-email': 'Nuova Email',
  'settings.new-email-placeholder': 'Inserisci il nuovo indirizzo email',
  'settings.change-email': 'Cambia email',
  'settings.email-verified-notice':
    "L'indirizzo email nel tuo account è già stato verificato.",
  'settings.to-join-notice':
    'Per unirti alle classi, devi prima verificare il tuo indirizzo email.',
  'settings.resend-email-notice': 'Puoi inviare nuovamente la verifica dopo 1 minuto.',
  'settings.verify-now': 'Verifica Ora',
  'settings.verification-sent':
    'La richiesta di verifica è stata inviata alla tua email.',
  'settings.email-verification': 'Verifica Email',
  'settings.change-email-address': 'Modifica Indirizzo E-mail',
  'settings.current-email-address': 'Indirizzo E-mail Attuale',
  'settings.classroom-notifications': 'Notifiche di Classroom',
  'settings.toggle-notifications':
    'Ricevi notifiche in classe tramite il mio indirizzo email.',
  'settings.untoggle-notifications':
    "Non desidero ricevere notifiche relative all'aula tramite la mia e-mail.",
  'settings.notification-miss-warning':
    'La scelta di questa opzione ti escluderebbe da qualsiasi attività correlata alla classe. Potresti perdere lezioni, compiti o aggiornamenti in diretta streaming.',
  'settings.email-language': "Lingua dell'Email",
  'settings.email-language-info':
    "Questo cambierà la lingua dell'email che stai ricevendo da noi. Attualmente supportiamo solo inglese e italiano.\n",
  'settings.save-language': 'Memorizza la lingua',
  'settings.notification-updated':
    'La tua preferenza di notifica via email è stata aggiornata!',
  'settings.preferred-updated': 'La lingua e-mail preferita è stata modificata!',

  //My Classrooms
  'my-classrooms.tab-created': 'CREATO',
  'my-classrooms.tab-enrolled': 'ISCRITTI',
  'my-classrooms.tab-archived': 'COMPLETATO',
  'my-classrooms.no-classrooms-to-teach':
    'Al momento non hai nessuna classe in cui insegnare.',
  'my-classrooms.create-classroom': 'Crea una classe ora',
  'my-classrooms.not-enrolled': 'Non sei ancora iscritto in nessuna classe.',
  'my-classrooms.join-classroom': 'Iscriviti a una classe ora',
  'my-classrooms.no-completed': 'Non hai ancora completato nessuna classe.',
  'my-classrooms.active-classroom.created-at': 'Creato al:',
  'my-classrooms.active-classroom.started-on': 'Aula iniziata il:',
  'my-classrooms.active-classroom.starts-in': 'Aula inizierà a:',
  'my-classrooms.active-classroom.target-language': 'Lingua da insegnare:',
  'my-classrooms.active-classroom.classroom-ratings': 'Valutazioni in aula:',
  'my-classrooms.active-classroom.share-link': 'Condividi il link',
  'my-classrooms.active-classroom.go-to-classroom': 'Vai in classe',
  'my-classrooms.active-classroom.view-your-profile': 'Vedi il tuo profilo',
  'my-classrooms.active-classroom.view-user-profile': 'Vedi il profilo utente',
  'my-classrooms.active-classroom.report-user': 'Segnala questo utente',
  'my-classrooms.archived-table.classroom-name': 'Nome della classe',
  'my-classrooms.archived-table.target-language': 'Lingua da insegnare',
  'my-classrooms.archived-table.creator': 'Creatore',
  'my-classrooms.archived-table.date-started': 'Data di inizio',
  'my-classrooms.archived-table.date-finished': 'Data di fine',
  'my-classrooms.archived-table.certificates': 'Certificati',
  'my-classrooms.archived-table.view-certificate': 'Vedi Certificato',
  'my-classrooms.number-of-raters': 'utenti hanno valutato questa classe.',
  'my-classrooms.add-rating-btn': 'Inserisci Valutazione',
  'my-classrooms.rating-title-form': 'Modulo di Valutazione',
  'my-classrooms.rating-label': 'Valutazione',
  'my-classrooms.rating-save-btn': 'Memorizza Valutazione',
  'my-classrooms.rating-saved': 'La tua valutazione è stata memorizzata!',
  'my-classrooms.comment-label': 'Commento (Facoltativo)',
  'classroom-creator-or-member.started-yet-insufficient': '',

  //Settings
  'email-change.email-exists':
    'The new email address you supplied is already in our records.',
  'email-change.email-same':
    'The new email address you supplied is already the same with your email in our records.',
  'email-change.email-unmatch':
    'The current email you supplied does not match the email you have in our records.',
  'email-change.email-invalid':
    'An anomaly has occurred. Please refrain from doing any suspicious activity!',
  'email-change.code-unmatch': 'The 6 digit code you entered do not match with our data.',
  'email-change.code-consumed': 'The 6 digit code you entered has already been used.',
  'email-change.code-expired': 'The 6 digit code you entered has already expired.',
  'email-change.success': 'Your email has been successfully changed!',
  'email-request.too-soon':
    'Please wait for a minute before requesting another verification.',
  'email-request.user-already-verified':
    'Your email has already been verified. Please refresh the page.',

  //Email Verify
  'verification-token.validating': 'Convalida token',
  'verification-token.success': 'La tua email è stata verificata!',
  'verification-token.invalid':
    'Il token non è valido. È possibile che sia già stato consumato o scaduto.',

  // Reset Password & Verify
  'reset-password.password-label': 'Password',
  'reset-password.re-password-label': 'Conferma la password',
  'reset-password.password-insufficient':
    'La password deve contenere almeno 6 caratteri.',
  'reset-password.passwords-not-matching': 'Le password non corrispondono.',
  'reset-password.reset-btn': 'Resetta la password',
  'reset-password.changing-failed': 'La modifica della password non è riuscita!',
  'reset-password.changing-success': 'La tua password è stata modificata!',
  'reset-password.sent-instructions':
    "Abbiamo inviato istruzioni su come reimpostare la password sulla tua e-mail. Se non ne hai ancora ricevuto uno, assicurati di aver inserito l'e-mail corretta.",
  'reset-password.email-sending-failed':
    'Invio richiesta non riuscita. Aggiorna la pagina e riprova il processo.',
  'reset-password.request-password-reset-btn': 'Richiesta di reimpostazione password',

  //General Position Localized
  'profile.educator': 'Educatore',
  'profile.student': 'Studente',
  'profile.M-educator': 'Professore',
  'profile.F-educator': 'Professoressa',
  'profile.M-student': 'Studente',
  'profile.F-student': 'Studentessa',

  //Create Classroom
  'user.not-eligible':
    'Sembra che non è consentito creare una classe per i seguenti motivi:',
  'user.not-educator-status':
    'Per saperne di più sul processo di candidatura completo, si prega di consultare questo link: ',
  'user.see-more-application-process-link': 'Come si applica come educatore?',
  'user.not-email-verified':
    "Devi verificare l'indirizzo e-mail che utilizzi nel tuo account.",
  'user.verify-link': 'Verifica ora',
  'user.not-educator-verified':
    'È necessario inviare una richiesta di domanda che sarà poi esaminata dal nostro personale.',
  'user.send-application-link': 'Invia richiesta ora',
  'user.reached-classrooms-limit':
    'Puoi avere solo tre (3) aule in corso per controllare il numero di aule create ogni giorno.',
  'user.set-classroom-complete-link': "Come impostare l'aula come completata?",
  'form.classroom-name': 'Nome della classe',
  'form.classroom-name-error':
    'Il nome della classe deve contenere solo da 6 a 128 caratteri.',
  'form.starting-date': 'Data di inizio',
  'form.starting-date-error': 'La data di inizio dovrebbe essere da 1 a 30 giorni.',
  'form.target-language': 'Lingua da insegnare',
  'form.target-language-placeholder': 'Scegli una lingua da insegnare.',
  'form.target-language-error': 'Devi specificare la lingua che insegnerai.',
  'form.classroom-description-placeholder': 'Perché dovrebbero unirsi alla tua classe?',
  'form.classroom-description-error':
    'La descrizione deve contenere da 32 a 4096 caratteri.',
  'form.creating-classroom': 'La classe è in fase di creazione',
  'form.create-classroom': 'Crea classe',
  'form.create-classroom-success': 'Classroom è stato creato!',
  'form.create-classroom-success-description':
    'Per ottenere il massimo dalla tua esperienza di insegnamento in classe, ecco una guida su',
  'form.create-classroom-success-link':
    "Massimizzare l'uso del Rich Text Editor nella creazione di lezioni e compiti in classe.",

  //Classroom Nav
  'classroom-nav.title': 'Portale Della Classe',
  'classroom-nav.leave-portal': 'Lascia il portale',
  'classroom-nav.lectures': 'Conferenze',
  'classroom-nav.assignments': 'Assegnazioni',
  'classroom-nav.chat': 'Chat',
  'classroom-nav.live-stream': 'Streaming',
  'classroom-nav.events': 'Eventi',
  'classroom-nav.help-center': 'Centro assistenza',
  'classroom-nav.settings': 'Impostazioni',
  'classroom-nav.leaving-dialog-agree': 'Esci',
  'classroom-nav.leaving-dialog-disagree': 'Annulla',
  'classroom-nav.leaving-dialog-title': 'Sei sicuro di voler lasciare il portale?',
  'classroom-nav.leaving-dialog-description':
    'Sarai reindirizzato alla tua lista di aule.',
  'classroom-me.modal-headings': 'Classroom non è ancora iniziato!',
  'classroom-me.modal-settings-btn': 'Vai alle impostazioni',
  'classroom-me.modal-descriptions':
    "Stiamo mostrando questo modale per ricordarti che l'aula non è ancora iniziata. Solo tu come creatore della classe puoi accedere al Portale della classe in questo momento. Hai la possibilità di avviare manualmente le impostazioni di Classroom. Almeno uno studente in classe devono essere iscritti per iniziare manualmente.",
  'classroom-member.not-started': "L'aula non è ancora iniziata.",

  //Report Form
  'report-form.user-dialog-title': 'Modulo di Segnalazione Violazione Utente',
  'report-form.lecture-dialog-title': 'Modulo di Segnalazione Violazione Lezione',
  'report-form.assignment-dialog-title': 'Modulo di Segnalazione Violazione Assegnazione',
  'report-form.chat-dialog-title': 'Modulo di Segnalazione Violazione Chat',
  'report-form.bug-dialog-title': "Modulo di Segnalazione Bug dell'Applicazione",
  'report-form.classroom-dialog-title': 'Modulo di Segnalazione Violazione della Classe',
  'report-form.violation-label': 'Tipo di Violazione',
  'report-form.helper-text-violation': 'Scegli una violazione.',
  'report-form.email-label': 'Indirizzo Email',
  'report-form.helper-text-email': "Inserisci un'e-mail in cui possiamo ricontattarti.",
  'report-form.description-label': 'Descrizione',
  'report-form.helper-text-description': 'Fornisci maggiori dettagli sulla violazione.',
  'report-form.button': 'Invia il rapporto',
  'report-form.submit-success': 'Il rapporto è stato inviato!',

  //Classroom Lectures
  'lectures.empty': 'Nessuna lezione ancora pubblicata. Rimanete sintonizzati!',
  'lectures.form-title': 'Titolo',
  'lectures.form-schedule-helper': 'Pianificare in anticipo',
  'lectures.form-schedule-more-info':
    'La lezione non verrà pubblicata nella dashboard fino al momento specificato.',
  'lectures.form-schedule': 'Posta in anticipo (Facoltativo)',
  'lectures.form-content-placeholder': 'Inserisci il contenuto della lezione qui',
  'lectures.form-title-error': 'Il titolo deve contenere da 1 a 128 caratteri.',
  'lectures.form-advance-schedule-error':
    'La data scelta non dovrebbe essere nel passato.',
  'lectures.form-content-error-empty': 'Il contenuto della lezione non può essere vuoto.',
  'lectures.form-content-error-exceeded':
    'Il contenuto della lezione ha superato i 10000 caratteri. Assicurati di controllare gli URL incorporati perché contengono testi lunghi.',
  'lectures.saving': 'Memorizzando la lezione',
  'lectures.saving-success': 'La lezione è stata salvata!',
  'lectures.lecture-box-date-created': 'Data di Creazione:',
  'lectures.lecture-box-date-updated': 'Ultimo Aggiornamento:',
  'lectures.lecture-box-send-report': 'Segnala lezione',
  'lectures.lecture-box-view-lecture': 'Vedi Lezione',
  'lectures.speed-dial-add': 'Inserisci',
  'lectures.speed-dial-save': 'Memorizza',
  'lectures.app-bar-title': 'Inserisci Lezione',
  'lectures.app-bar-button': 'Memorizza Lezione',
  'lectures.set-advance-helper':
    'Questo verrà pubblicata in anticipo. Solo tu puoi vedere questo.',

  // CommentsBlock Component
  'comments-block.comments': ' Commenti',
  'comments-block.no-comments':
    'Non ci sono ancora commenti. Perché non avviare una conversazione?',
  'comments-block.send-your-thoughts': 'Manda i tuoi pensieri qui',
  'comments-block.send-label': 'Il tuo commento',
  'comments-block.comment-empty': 'Il commento non può essere vuoto.',
  'comments-block.comment-exceeded': 'Solo 256 caratteri. Sei entrato:',
  'lecture.not-exist': 'La lezione non è stata trovata.',

  // Lecture View
  'lecture.not-found': 'La lezione non è stata trovata.',
  'lecture.lecture-content': 'Contenuto della Lezione:',
  'translation.confidence-too-low':
    'Impossibile rilevare automaticamente la lingua di origine, sicurezza troppo bassa.',
  'translation.translate-button': 'Traduci',
  'lecture.breadcrumbs-lectures': 'Lezioni',
  'lecture.app-bar-edit-title': 'Modifica Lezione',
  'lecture.app-bar-edit-button': 'Memorizza le modifiche',
  'lecture.editing-success': 'La lezione è stata modificata.',
  'lectures.editing': 'La lezione è in fase di modifica.',
  'lectures.delete-agree': 'Lo rimuovi ora',
  'lectures.title-assurance-delete': 'Sei sicuro di eliminare la lezione?',
  'lectures.warn-before-delete':
    'Questa azione è irrevocabile. Non sarai in grado di recuperare questa lezione in futuro.',
  'lectures.deleting': 'Eliminando questa lezione...',
  'lectures.deleting-success': 'La lezione è stata rimossa!',
  'lectures.deleting-error': 'Questo è un errore raro. Aggiorna la pagina e riprova.',

  // Assignments
  'assignments.empty': 'Non preoccuparti! Nessun compito ancora da inviare.',
  'assignments.form-schedule-more-info':
    'Il compito non verrà pubblicata nella dashboard fino al momento specificato.',
  'assignments.form-submission-time': 'Tempo di Invio (Facoltativo)',
  'assignments.app-bar-title': 'Inserisci Compito',
  'assignments.app-bar-button': 'Memorizza Compito',
  'assignments.form-content-placeholder': 'Inserisci il contenuto del compito qui',
  'assignments.form-content-error-empty':
    'Il contenuto del compito non può essere vuoto.',
  'assignments.form-content-error-exceeded':
    'Il contenuto del compito ha superato i 10000 caratteri. Assicurati di controllare gli URL incorporati perché contengono testi lunghi.',
  'assignment-form.submission-past-advance':
    "Il tempo di presentazione dovrebbe essere in anticipo rispetto alla pubblicazione programmata dell'attività.",
  'assignment-form.submission-time-past':
    "L'orario di presentazione deve essere in anticipo rispetto all'ora corrente.",
  'assignments.assignment-box-submission-time': 'Scadenza:',
  'assignments.assignment-box-no-submission': 'Nessuna Scadenza',
  'assignments.assignment-box-view-assignment': 'Vedi il compito',
  'assignments.assignment-box-send-report': 'Segnala il compito',
  'assignments.assignment-box-send-deadline-warning':
    'Hai meno di un giorno per svolgere il tuo compito.',
  'assignments.saving-success': "L'assegnazione è stata memorizzata sul nostro server!",
  'assignments.saving': "Memorizzando l'assegnazione",

  // Assignment Creator View
  'creator-assignment-view.secure-page-info':
    'Questa è una pagina sicura. Solo tu come creatore puoi vederlo.',
  'creator-assignment-view.assignments-breadcrumb': 'Compiti',
  'creator-assignment-view.edit': 'Modifica Compito',
  'creator-assignment-view.delete': ' Rimuovi Compito',
  'assignment.editing-success': 'Il compito è stato modificato.',
  'assignment.editing': 'Il compito è in fase di modifica.',
  'assignment.deleting': 'Eliminando questo compito...',
  'assignment.deleting-success': 'Il compito è stato cancellato!',
  'assignment.title-assurance-delete': 'Sei sicuro di eliminare il compito?',
  'assignment.warn-before-delete':
    'Questa azione è irrevocabile. Non sarai in grado di recuperare questo compito in futuro.',
  'assignment.not-found': 'Il compito non è stato trovato.',
  'creator-assignment.view': 'Vedi',
  'creator-assignment.submissions': 'Consegne',

  // Assignment View Content
  'assignment-view-content.deadline': 'Scadenza:',
  'assignment-view-content.assignment-content': 'Contenuto del Compito:',

  // Submissions
  'submissions.fetching': 'Ottenere consegne...',
  'submissions.breadcrumb-submission': 'Consegne',
  'submissions.students-on-time': 'Studenti che hanno consegnato in tempo',
  'submissions.no-submissions-label':
    'Al momento non ci sono consegne per questa categoria.',
  'submissions.students-late': 'Studenti che hanno consegnato in ritardo',
  'submissions.students-no-submissions': 'Studenti senza ancora consegne',
  'submissions.view-submission': 'Vedi la consegna',
  'submissions.user-no-submission': 'Nessuna consegna ancora per questo utente',

  // Submission View
  'assignment-submission.forbidden': 'È vietato eseguire ulteriori azioni.',
  'assignment-submission.not-exist':
    'Questa consegna non è stata trovata. Potrebbe essere cancellata.',
  'assignment-submission.breadcrumb-submission-of': 'Consegna di',
  'assignment-submission.breadcrumb-your-submission': 'La tua consegna',
  'assignment-submission.submitter-info': 'Informazioni sul proprietario della consegna:',
  'assignment-submission.status': 'Stato:',
  'assignment-submission.status-returned': 'Tornato',
  'assignment-submission.status-on-time': 'Consegnato in tempo',
  'assignment-submission.status-late': 'Presentato in ritardo',
  'assignment-submission.score': 'Punto:',
  'assignment-submission.edit-mark': 'Modifica il punteggio',
  'assignment-submission.give-mark': 'Dai un punteggio',
  'assignment-submission.submission-content': 'Contenuto della consegna:',
  'assignment-submission.edit-submit-tooltip': 'Modifica la consegna',
  'assignment-submission.delete-submit-tooltip': 'Rimuovi la consegna',
  'assignment-submission.title-assurance-delete':
    'Sei sicuro di eliminare la tua presentazione?',
  'assignment-submission.warn-before-delete':
    'Questa azione è irrevocabile. Non sarai in grado di recuperare questa consegna in futuro.',
  'assignment-submission.given-score': 'Punteggio assegnato',
  'assignment-submission.total': 'Totale',
  'assignment-submission.give-score-title': 'Dai un punteggio',
  'assignment-submission.give-score-guide':
    'Assicurati di dare uguali punteggi totali in questa attività per tutte le presentazioni.',
  'assignment-submission.updating-changes': 'Aggiornamento delle modifiche alla consegna',
  'assignment-submission.edited-changes':
    'La tua presentazione è stata modificata con successo!',
  'assignment-submission.deleted-changes':
    'La tua presentazione è stata cancellata con successo!',
  'assignment-submission.saving-score': 'Memorizzando il punteggio dello studente',
  'assignment-submission.saved-score':
    'Il punteggio dello studente è stato pubblicato con successo.',
  'assignment-submission.view-my-submission': 'Vedi la mia consegna',
  'assignment-submission.add-submission': 'Inserisci una consegna',
  'assignment-submission.turning-in': 'Trasmissione della presentazione in ...',
  'assignment-submission.turned-in': 'Il tuo compito è stato consegnato!',
  'given-score.cannot-exceed-total':
    'Il punteggio assegnato non può superare il punteggio totale.',
  'total-score.cannot-exceed-100': 'Il punteggio totale non può superare 100.',
  'given-score.cannot-be-zero': 'Il punteggio assegnato non può essere zero.',
  'total-score.cannot-be-zero': 'Il punteggio totale non può essere zero.',

  // Chat
  'user-info-dialog': 'Informazioni Utente',
  'chat.send-message-label': 'Il Tuo Messaggio',
  'chat.send-message-error': 'Il messaggio deve contenere solo da 1 a 1024 caratteri.',
  'chat.fetching-messages': "Ottenere l'elenco dei messaggi",
  'chat.classroom-chat-main': 'Chat di Classroom',
  'chat.report-chat': 'Segnala Chat',
  'chat.messages-label': 'Messaggi',
  'chat.personal-message': 'Messaggio Personale',
  'chat.added-all-users': 'Hai inserito tutti gli utenti consentiti.',
  'chat.user-added': "L'utente è stato inserito.",
  'main-chat.not-exist':
    'La chat principale della classe non è stata trovata. Si prega di aggiornare la pagina.',
  'sub-chat.exists-already':
    'È già stata creata una finestra di chat con questo utente. Aggiorna la pagina per vedere le ultime modifiche.',
  'chat-sending.failed': "Si è verificato un errore durante l'invio del messaggio.",
  'chat.popper-view-user': 'Vedi Informazioni Utente',
  'chat.popper-report-user': 'Segnala Utente',
  'chat.ago': 'fa',
  'chat.conversation-not-started':
    'La conversazione non è ancora iniziata con questo utente. Perché non avviarne uno?',
  'chat.conversation-not-started-main': 'Nessuna conversazione iniziata ancora.',
  'chat.view-more': 'Vedi di più',

  // Events
  'events.event-form-button-agree': 'Crea',
  'events.event-form-title-dialogue': "Modulo di Creazione dell'Evento",
  'events.event-form-title': 'Titolo del Evento',
  'events.event-form-desc': 'Descrizione del Evento',
  'events.event-form-title-error': "L'evento deve contenere 1 - 128 caratteri.",
  'events.event-form-start': "Data di inizio dell'evento",
  'events.event-form-start-error': 'Inserisci una data di inizio valida.',
  'events.event-form-start-error-past':
    'I dati di avvio non dovrebbero avvenire in passato.',
  'events.event-form-end': "Data di fine dell'evento",
  'events.event-form-end-not-a-number': 'Inserisci una data di fine valida.',
  'events.event-form-end-recedes-start':
    'La data di fine non può avvenire oltre la data di inizio.',
  'events.fetching': "Ottenere l'elenco degli eventi",
  'events.event-created': "L'evento è stato creato!",
  'events.event-more-details': "Dettagli dell'Evento",
  'events.event-edited': "L'evento è stato modificato!",
  'events.event-form-create-button': 'Crea',
  'events.event-form-edit-button': 'Modifica',
  'events.title-assurance-delete': "Sei sicuro di eliminare l'evento?",
  'events.warn-before-delete':
    "Questa azione è irrevocabile. Non sarai in grado di recuperare quest'evento in futuro.",
  'events.event-deleted': "L'evento è stato rimosso!",

  // Classroom Settings
  'classroom-settings.settings': 'Impostazioni di Classroom',
  'classroom-settings.resuming-warning':
    "Classroom è già terminata. Cercare di riprendere l'aula fallirà se hai già 3 aule in corso.",
  'classroom-settings.resume-btn': 'Riprendi il classroom',
  'classroom-settings.title-label': 'Titolo del Classroom',
  'classroom-settings.set-as-completed': 'Imposta Classroom come Completato',
  'classroom-settings.re-input': "Reinserisci il titolo dell'aula per procedere",
  'classroom-settings.end-btn': "Imposta l'aula come finita",
  'classroom-settings.students-enrolled': 'Studenti iscritti:',
  'classroom-settings.start-btn': 'Inizia manualmente',
  'classroom-settings.start-helper':
    "Quando il numero di iscritti raggiunge 1 o più, puoi avviare l'aula manualmente.",
  'classroom-settings.starting': 'La classe è in fase di avvio',
  'classroom-settings.force-starting':
    'Forza il riavvio della pagina al termine del processo...',
  'classroom-me.go-back': 'Torna indietro',
  'classroom-me.checkpoint': 'Punto di controllo lungo la strada. Per favore fermati!',
  'classroom-me.off-limits-highlight': 'Questo posto è vietato!',
  'classroom-me.off-limits': 'Potresti essere perso. Per favore, fai un passo indietro.',
  'classroom-me.classroom-yet-to-start': 'Classroom non è ancora iniziato.',
  'classroom-me.number-of-enrolless': 'Numero di iscritti:',
  'classroom-me.no-student':
    "Il timer di avvio è già terminato ma l'aula non ha studenti iscritti.",
  'classroom-me.classroom-deleted':
    "Questa classe verrà eliminata automaticamente entro il giorno. Ci dispiace per l'inconvenienza.",
};
